const clearDataFromStorage = () => {
  localStorage.removeItem('user');
  sessionStorage.removeItem('SEEN_SPLASH');
};
const storeUserInfoIntoStorage = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export { clearDataFromStorage, storeUserInfoIntoStorage };
